import { render } from "./ContactPage.vue?vue&type=template&id=5bb43b89&ts=true"
import script from "./ContactPage.vue?vue&type=script&lang=ts"
export * from "./ContactPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__